import { Dispatch } from '../../../redux/redux.types';
import { BrowserAssetType } from '../../../types/media-assets';

export const CURRENT_FILE_ASSETS_ACTIONS = {
  FILE_SELECT: 'CURRENT_FILE_ASSETS_ACTIONS.FILE_SELECT',
  RESET_SELECTED_FILES: 'CURRENT_FILE_ASSETS_ACTIONS.RESET_SELECTED_FILES',
};

const selectFileSuccess = (fileId: string, type: BrowserAssetType) => ({
  type: CURRENT_FILE_ASSETS_ACTIONS.FILE_SELECT,
  payload: {
    fileId,
    type,
  },
});

export const resetSelectedFiles = () => ({
  type: CURRENT_FILE_ASSETS_ACTIONS.RESET_SELECTED_FILES,
  payload: undefined,
});

export const selectFile =
  (fileId: string, type: BrowserAssetType) => (dispatch: Dispatch) => {
    return dispatch(selectFileSuccess(fileId, type));
  };
